export const CHANGE_SINGER_LIST = 'singers/CHANGE_SINGER_LIST';
export const CHANGE_PAGE_COUNT = 'singersCHANGE_PAGE_COUNT';
export const CHANGE_ENTER_LOADING = 'singers/CHANGE_ENTER_LOADING';
export const CHANGE_PULLUP_LOADING = 'singers/CHANGE_PULLUP_LOADING';
export const CHANGE_PULLDOWN_LOADING = 'singers/CHANGE_PULLDOWN_LOADING';
